// extracted by mini-css-extract-plugin
export default {"wrapper":"NewsAndEvents_wrapper__QRfkQ","news_list":"NewsAndEvents_news_list__mNPVD","title":"NewsAndEvents_title__Jxl87","description":"NewsAndEvents_description__yzsg9"};